import React, { useRef, useEffect, useState } from 'react';

const LocationAutocomplete = ({
    onPlaceSelected = () => {},
    onCleared = () => {}
}) => {
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (!window.google || !window.google.maps || !window.google.maps.places) {
            console.error("Google Maps Places API is not loaded");
            return;
        }

        if (!inputRef.current) {
            console.error("Input ref is not available");
            return;
        }

        try {
            autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: ['(cities)'],
                componentRestrictions: { country: 'in' }
            });

            if (autocompleteRef.current) {
                autocompleteRef.current.addListener('place_changed', () => {
                    const place = autocompleteRef.current?.getPlace();
                    if (inputRef.current) {
                        setInputValue(inputRef.current.value); // Update input value
                    }
                    onPlaceSelected(place);
                });
            }
        } catch (error) {
            console.error("Error initializing Google Maps Autocomplete:", error);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (value === '') {
            onCleared(); // Call parent to reset location
        }
    };

    return (
        <input
            type="text"
            ref={inputRef}
            className="form-control"
            placeholder="Enter location"
            value={inputValue}
            onChange={handleChange}
        />
    );
};

export default LocationAutocomplete;
